import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  hide() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = 'none';
      this.overlayTarget.classList.add('d-none');
    }
  }

  show() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = 'flex';
      this.overlayTarget.classList.remove('d-none');
    }
  }
}
